// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '고려제약',
  targetSheetName: '원본 (계약서용)',
  headerRowIndex: 4,
  headerRowCount: 1,
  dataStartRowIndex: 5,
  requiredHeaders: [
    '대분류',
    '소분류',
    '성분•함량',
    '제품명',
    '약가',
    '보험코드',
    '포장단위',
    '수수료(%)',
    '비고',
  ],
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료(%)',
    commissionNote: '비고',
  },
});
